import { useRouter } from "@/i18n/navigation";
import { useTranslations } from "next-intl";
import { StaticImageData } from "next/image";
import { useCallback } from "react";
import Egypt from "~/public/flags/Egypt.svg";
import England from "~/public/flags/England.svg";
import Spain from "~/public/flags/Spain.svg";
import Germany from "~/public/flags/Germany.svg";
import Portugal from "~/public/flags/Portugal.svg";
import France from "~/public/flags/France.svg";

export type LangCode = "ar" | "en" | "es" | "de" | "pt" | "fr";

export type Lang = {
  code: LangCode;
  label: string;
  flag: StaticImageData;
};

export const useLangs = () => {
  const t = useTranslations();

  return [
    { code: 'en', label: t('default.english'), flag: England },
    { code: 'ar', label: t('default.arabic'), flag: Egypt },
    { code: 'es', label: t('default.spanish'), flag: Spain },
    { code: 'de', label: t('default.german'), flag: Germany },
    { code: 'pt', label: t('default.portuguese'), flag: Portugal },
    { code: 'fr', label: t('default.french'), flag: France },
  ] as Lang[];
}


export function useChangeLang() {
  const router = useRouter();

  // use callback 
  return useCallback(function changeLanguage(locale: LangCode) {
    // Set the locale cookie
    document.cookie = `locale=${locale}; path=/; max-age=31536000`; // 1 year expiry
    
    // Refresh the page to apply the new locale
    router.refresh();
  }, [router]);
}
